import { tenants } from "../../config/tenants.js";
import type { LocalizedString } from "../Locale.js";

export const homepagePathMap = Object.fromEntries(
	Object.values(tenants).map(({ locale, prefix }) => [locale, prefix.slice(1)]),
) as LocalizedString;
